export default __webpack_public_path__ + "static/media/pourquoi-deposer-une-offre.9dcdce45.jpg";